import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';
import { I18n, Icon, Status } from 'components';
import { Slide } from '../Slide';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const Sliders = ({
  isSwitchChecked, isProcessing, settledLimitsFunc, accumulators = [], isShowStatus,
}) => (
  <div className={cn('setup')}>
    <div className={cn('setup__title')}>
      <Text size="size4-m">
        <I18n path="family.ctnSetupTexts.ctnSettingsTitle" />
      </Text>
    </div>
    <div className={cn('setup__description')}>
      <Text size="size5-r-s">
        <I18n path="family.ctnSetupTexts.ctnLimitsText" />
      </Text>
    </div>
    {isShowStatus && (
      <Status className={['attention', cn('setup__status')]}>
        <Text size="size5-r-s">
          <Icon name="info" className={cn('setup__status-icon')} />
          <I18n path="family.setFamilyChildLimitsStatus" />
        </Text>
      </Status>
    )}
    <div className={cn('setup__slider')} key="slider">
      {accumulators.map((slide) => (slide?.unlimited ? null : (
        <div className={cn('setup__slide')} key={slide.name}>
          <Slide
            name={slide.name}
            step={slide.step}
            unit={slide.unit}
            limit={slide.limit}
            balance={slide.balance}
            isProcessing={isProcessing}
            parentLimit={slide.parentLimit}
            isSwitchChecked={isSwitchChecked}
            settledLimitsFunc={settledLimitsFunc}
          />
        </div>
      )))}
    </div>
  </div>
);

Sliders.propTypes = {
  settledLimitsFunc: PropTypes.func,
  accumulators: PropTypes.arrayOf({
    name: PropTypes.string,
    balance: PropTypes.number,
    limit: PropTypes.number,
    unit: PropTypes.string,
    step: PropTypes.number,
    parentLimit: PropTypes.number,
    isProcessing: PropTypes.bool,
  }),
  isSwitchChecked: PropTypes.bool,
  isProcessing: PropTypes.bool,
  isShowStatus: PropTypes.bool,
};

export { Sliders };
